import React from "react";
import { Outlet } from "react-router";
import RouteLayout from "../../../Components/Layout/RouteLayout";

function EmployeeService() {
  return (
    <RouteLayout title={"Employee Service/"}>
      <Outlet />
    </RouteLayout>
  );
}

export default EmployeeService;
